import { omdApi } from 'bus/api';

import { PayloadRequest } from 'types/requestTypes';

import { TrailerCreate, TrailerDetail, TrailerEdit } from '../Trailer.entity';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getTrailerDetail: builder.query<TrailerDetail, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Trailer/${data.id}`,
      }),
    }),
    changeTrailer: builder.mutation<void, TrailerEdit>({
      query: (data) => ({
        url: `/v1/Trailer/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createTrailer: builder.mutation<void, TrailerCreate>({
      query: (data) => ({
        url: '/v1/Trailer',
        method: 'POST',
        body: data,
      }),
    }),
    deleteTrailer: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Trailer/${data.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useChangeTrailerMutation,
  useCreateTrailerMutation,
  useGetTrailerDetailQuery,
  useLazyGetTrailerDetailQuery,
  useDeleteTrailerMutation,
} = request;
